import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Results" className="border-y border-grape-soft/30 bg-white/70" data-id="element-273" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-274" data-mp="2wvdtpr8o3u1o">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-275" data-mp="2nx1wh6dapy09">
          {stats.map(s => <div key={s.label} className="flex flex-col-reverse text-center" data-id="element-276" data-mp="2nz4w8i4935i6">
              <dt className="mt-1 text-sm font-medium text-plum/60" data-id="element-277" data-mp="296kzq0blvw9p">{s.label}</dt>
              <dd className="font-display text-4xl font-black text-plum sm:text-5xl" data-id="element-278" data-mp="2dznta8gdv5pw">{s.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}